import React, { useState, useEffect } from 'react';
import {Alert} from 'reactstrap';
import '../Contacto/Contacto.scss';

import api from '../../components/Tienda/api';
import apifunctions from '../../components/Tienda/api/functions.js';

const AlertMensaje = (props) => {
	const Mensajes = [
		" Enviando ...",
		" Su CV ha sido enviado con exito",
		" Fallo el registro de CV, intentelo nuevamente más tarde."
	];
	const ClassNames = [
		"alert-info",
		"alert-success",
		"alert-danger",
	];
	return props.Estado > 0 && (props.Estado - 1) < Mensajes.length && (
		<Alert className={ClassNames[props.Estado - 1]}>
			{props.Estado === 1 && (<i className="fa fa-spinner fa-spin" aria-hidden="true"></i>)}
			{props.Estado === 2 && (<i className="fa fa-check" aria-hidden="true"></i>)}
			{props.Estado === 3 && (<i className="fa fa-times" aria-hidden="true"></i>)}
			{Mensajes[props.Estado - 1]}
		</Alert>
	);
}

const EnviaTuCV = (props) => {

	let envioTimeout = 0;

	/* 0 - Sin ENVIAR; 1 - Enviando; 2 - Exito; 3 - Fallo; */
	const [envioState, updateEnvioState] = useState(0);

	const [formState, updateState] = useState({
		NombreCompleto : '',
		Email : '',
		Direccion : '',
		Telefono : '',
		Ciudad : '',
		Provincia : '',
		Profesion : '',
		Interes : '',
		ExperienciaLaboral : '',
		Referencias : '',
		FechaNac : '',
		Mensaje : '',
	});

	const updateFormState = (prop, val) => updateState({ ...formState, [prop]:val, });

	const SendMail = () => {

		let enviar = false;

		const fieldNames = {
			NombreCompleto: 		"Nombre y Apellido",
			Email:	 						"Email",
			Direccion:					"Direccion",
			Telefono : 					"Teléfono",
			Ciudad:							"Ciudad",
			Provincia:					"Provincia",
			Profesion:					"Profesion",
			Interes:						"Área de interés",
			ExperienciaLaboral:	"Experiencia Laboral",
			Referencias:				"Referencias",
			FechaNac:						"Fecha de Nacimiento",
			Mensaje:						"Comentarios",
		}

		let fomularioEnviaTuCV = document.getElementById("fomularioEnviaTuCV");
		if(fomularioEnviaTuCV !== undefined && fomularioEnviaTuCV !== null){
			let data = new FormData();

			Object.keys(fieldNames).forEach((field, index) => {
				if(formState[field] !== undefined && formState[field] != null && formState[field].length > 0){
					data.append(`NombresCampos[${index}]`, fieldNames[field]);
					data.append(`ValoresCampos[${index}]`, formState[field]);
				}
			});

			let attachedCV_node = document.getElementById("attachedCV");
			if (attachedCV_node !== undefined && attachedCV_node !== null && attachedCV_node.files !== null && attachedCV_node.files.length === 1){
				data.append("Adjunto", attachedCV_node.files[0]);
			}

			data.append("Asunto", "ENVIO DE CV");

			const successCallback = (resp) => {
				clearTimeout(envioTimeout);
				envioTimeout = setTimeout(()=>updateEnvioState(0), 2500);
				updateEnvioState(resp && resp.success ? 2 : 3);
			}
			const failureCallback = () => {
				clearTimeout(envioTimeout);
				envioTimeout = setTimeout(()=>updateEnvioState(0), 2500);
				updateEnvioState(3);
			};

			enviar = fomularioEnviaTuCV.getElementsByClassName("is-invalid").length === 0;

			if (enviar){
				clearTimeout(envioTimeout);
				envioTimeout = setTimeout(()=>updateEnvioState(0), 2500);
				updateEnvioState(1);

				apifunctions.post(api.api.sitio.contacto, null, data, successCallback, failureCallback, failureCallback);
			}
		}
	}

	const validationClass = (classNames, val, minLength) => val && val.length > minLength ? `${classNames} is-valid` : `${classNames} is-invalid`;

	useEffect(()=>document.querySelector('html').scrollTo(0, 0), []);

	return (
		<>
			<section className="bgTitle bgContacto py-10">
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<h2>TRABAJÁ CON NOSOTROS</h2>
							<h3>ENVIANOS TU CV</h3>
						</div>
					</div>
				</div>
			</section>
			<section className="last">
				<div className="container">
					<div className="row">
						<div className="col-sm-8 offset-sm-2 mb-5">
							<form id="fomularioEnviaTuCV" onSubmit={()=>(false)}>
								<div className="form-group">
									<input type="text" name="NombreCompleto" placeholder="Nombre y Apellido"
										className={validationClass("form-control", formState["NombreCompleto"], 10)}
										onChange={(evt)=>updateFormState("NombreCompleto", evt.target.value)}
									/>
								</div>
								<div className="form-group">
									<input type="email" name="Email" placeholder="Su e-mail"
										className={validationClass("form-control", formState["Email"], 10)}
										onChange={(evt)=>updateFormState("Email", evt.target.value)}
									/>
								</div>
								<div className="form-group">
									<input type="text" name="Telefono" placeholder="Teléfono"
										className={validationClass("form-control", formState["Telefono"], 5)}
										onChange={(evt)=>updateFormState("Telefono", evt.target.value)}
									/>
								</div>
								<div className="form-group">
									<input type="text" name="Direccion" placeholder="Su dirección"
										className={validationClass("form-control", formState["Direccion"], 5)}
										onChange={(evt)=>updateFormState("Direccion", evt.target.value)}
									/>
								</div>
								<div className="row">
									<div className="form-group col-sm-6">
										<input type="text" name="Ciudad" placeholder="Ciudad"
											className={validationClass("form-control", formState["Ciudad"], 5)}
											onChange={(evt)=>updateFormState("Ciudad", evt.target.value)}
										/>
									</div>
									<div className="form-group col-sm-6">
										<input type="text" name="Provincia" placeholder="Provincia"
											className={validationClass("form-control", formState["Provincia"], 5)}
											onChange={(evt)=>updateFormState("Provincia", evt.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-group col-sm-6">
										<input type="date" name="FechaNac" placeholder="Fecha de Nacimiento"
											className={validationClass("form-control", formState["FechaNac"], 5)}
											onChange={(evt)=>updateFormState("FechaNac", evt.target.value)}
										/>
									</div>
									<div className="form-group col-sm-6">
										<input type="file" id="attachedCV" className="form-control " placeholder="Adjuntar CV" />
									</div>
								</div>
								<div className="form-group">
									<input type="text" name="Profesion" placeholder="Su profesión"
										className={validationClass("form-control", formState["Profesion"], 5)}
										onChange={(evt)=>updateFormState("Profesion", evt.target.value)}
									/>
								</div>
								<div className="form-group">
									<input type="text" name="Interes" placeholder="Área de interés"
										className="form-control"
										onChange={(evt)=>updateFormState("Interes", evt.target.value)}
									/>
								</div>
								<div className="form-group">
									<input type="text" name="ExperienciaLaboral" placeholder="Experiencia laboral"
										className="form-control"
										onChange={(evt)=>updateFormState("ExperienciaLaboral", evt.target.value)}
									/>
								</div>
								<div className="form-group">
									<input type="text" name="Referencias" placeholder="Referencias"
										className="form-control"
										onChange={(evt)=>updateFormState("Referencias", evt.target.value)}
									/>
								</div>
								<div className="form-group">
									<textarea className="form-control" name="Mensaje" placeholder="Sus comentarios" rows="4" onChange={(evt)=>updateFormState("Mensaje", evt.target.value)}></textarea>
								</div>
								<AlertMensaje Estado={envioState}/>
								<div className="text-center mb-3">
									<button onClick={()=>SendMail()} type="button" className="btn btn-lg btn-primary"> ENVIAR <i className="fa fa-envelope-o" aria-hidden="true"></i> </button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</section>
		</>
);
}

export default EnviaTuCV;
